const GOOGLE_API_KEY = 'gme-priceminister1';
const COOKIE_NAME = 'PMGeolocUserGeolocation';
const MIN_RADIUS = 1;
const MAX_RADIUS = 100;
const DEFAULT_RADIUS = 30;
const DEFAULT_ZOOM = 5;
const DEFAULT_LAT = 46.227638;
const DEFAULT_LNG = 2.213749000000007;
const CIRCLE_STROKE_COLOR = '#1F55AD';
const CIRCLE_STROKE_OPACITY = 0.8;
const CIRCLE_STROKE_WEIGHT = 2;
const CIRCLE_FILL_COLOR = '#1F55AD';
const CIRCLE_FILL_OPACITY = 0.35;
// eslint-disable-next-line max-len
const USER_GEOLOC_MARKER = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAhklEQVQoz2NQCF3LgIRFgLgNiC8B8Q8ovgDETVA5uFpkTcFA/AGI/+PAH6FqUDSCBP7h0QTD/2CaQZpEoab9JxKD1IoxQN3/n0TcxgD1PKkaLzFAQ45UjT/J1fiZXKdepChwxMiNDrITAAyHAPEnPJo+YUty6In8MhD/AuIvQHwOiJvREzkAQK52wm5ptH0AAAAASUVORK5CYII=';
const GEOLOC_PARAM = 'sh=pkp';

export {
  GOOGLE_API_KEY, COOKIE_NAME, MIN_RADIUS, MAX_RADIUS,
  DEFAULT_RADIUS, DEFAULT_ZOOM, DEFAULT_LAT, DEFAULT_LNG,
  CIRCLE_STROKE_COLOR, CIRCLE_STROKE_OPACITY, CIRCLE_STROKE_WEIGHT,
  CIRCLE_FILL_COLOR, CIRCLE_FILL_OPACITY,
  USER_GEOLOC_MARKER, GEOLOC_PARAM,
};
